import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import { InvalidTokenError } from "../CustomError";
import { RoutesService } from "../Services";
import http from "./http";

export const AUTH_BASE_URL = "/auth/";

class TokenManager {
	getAccessToken() {
		const access_token = localStorage.getItem("access_token");
		return access_token;
	}

	setAccessToken(value) {
		localStorage.setItem("access_token", value);
	}

	async getNewAccessToken(refresh_token) {
		const { access_token } = await http.post(`${AUTH_BASE_URL}refreshToken`, {
			refresh_token
		});

		if (typeof access_token === "string") localStorage.setItem("access_token", access_token);
	}

	getRemainingTime(token) {
		const decoded_token = jwtDecode(token);
		if (decoded_token) {
			const currentTimestamp = Math.floor(Date.now() / 1000);
			const remainingTime = decoded_token.exp - currentTimestamp;
			return remainingTime * 1000;
		}
		return 0;
	}

	getRefreshToken() {
		let refresh_token = localStorage.getItem("refresh_token");
		if (typeof refresh_token === "string") return refresh_token;
		else throw new InvalidTokenError();
	}

	setRefreshToken(value) {
		localStorage.setItem("refresh_token", value);
		const time = this.getRemainingTime(value);

		setTimeout(() => {
			this.clear();

			window.addEventListener("focus", () => {
				toast.warning("Your session has expired. Redirecting to login page.");
				setTimeout(() => {
					window.location.replace(RoutesService.getLoginRoute());
				}, 5000);
			});
		}, time);
	}

	isAccessTokenValid() {
		const token = localStorage.getItem("access_token");
		if (token) {
			const decoded = jwtDecode(token);
			const currentTimestamp = Date.now() / 1000;
			return decoded.exp < currentTimestamp ? false : true;
		}
		return false;
	}

	clear() {
		localStorage.clear();
	}
}

const Token_Manager = new TokenManager();

const userServices = {
	login: async values => {
		let response = await http.post(`${AUTH_BASE_URL}login`, values);
		const user = response.data;
		const { access_token } = user;
		Token_Manager.setAccessToken(access_token);
		// Token_Manager.setRefreshToken(refresh_token);

		return user;
	},
	checkIFValid: () => {
		return Token_Manager.isAccessTokenValid();
	},

	signOut: () => {
		Token_Manager.clear();
		window.location.href = RoutesService.getLoginRoute();
	},

	getAccessToken: () => {
		return Token_Manager.getAccessToken();
	},
	getCurrentUser: () => {
		const token = Token_Manager.getAccessToken();
		if (!token) return null;
		const user = jwtDecode(token);
		if (user) return user;
		// else Token_Manager.clear();

		return null;
	}
};

export default userServices;
